export const USER_ACCOUNT_ACTIVATION_TOGGLE_MODES = {
  ACTIVATE: 'activate',
  DEACTIVATE: 'deactivate',
};

export const USER_ACCOUNT_ACTIVATION_TOGGLE_CONTENT = {
  [USER_ACCOUNT_ACTIVATION_TOGGLE_MODES.ACTIVATE]: {
    card: {
      headerKey: 'userDetail.reactivateAccount.header',
      bodyKey: 'userDetail.reactivateAccount.body',
      actionLabelKey: 'userDetail.reactivateAccount.reactivate',
      headerTestId: 'reactivate-account-header',
      actionTestId: 'reactivate-account-action',
    },
    confirmation: {
      headerKey: 'user.account.reactivation.acknowledgement.header',
      bodyKey: 'user.account.reactivation.acknowledgement.body',
      checkboxLabelKey: 'user.account.reactivation.acknowledgement.confirmation',
      checkboxName: 'accountReactivationCheckbox',
      confirmLabelKey: 'generic.reactivate',
    },
  },
  [USER_ACCOUNT_ACTIVATION_TOGGLE_MODES.DEACTIVATE]: {
    card: {
      headerKey: 'userDetail.accountDeactivation.header',
      bodyKey: 'userDetail.accountDeactivation.body',
      actionLabelKey: 'userDetail.accountDeactivation.action',
      headerTestId: 'remove-account-header',
      actionTestId: 'remove-account-action',
    },
    confirmation: {
      headerKey: 'user.account.deactivation.acknowledgement.header',
      bodyKey: 'user.account.deactivation.acknowledgement.body',
      checkboxLabelKey: 'user.account.deactivation.acknowledgement.confirmation',
      checkboxName: 'accountDeactivationCheckbox',
      confirmLabelKey: 'generic.deactivate',
    },
  },
};
